import { render, staticRenderFns } from "./FinanceStatement.vue?vue&type=template&id=0bf8c5cc&scoped=true"
import script from "./FinanceStatement.vue?vue&type=script&lang=js"
export * from "./FinanceStatement.vue?vue&type=script&lang=js"
import style0 from "./FinanceStatement.vue?vue&type=style&index=0&id=0bf8c5cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf8c5cc",
  null
  
)

export default component.exports